export const config = {
  // Analytics
  analytics: {
    googleAnalyticsId: import.meta.env.VITE_GA_TRACKING_ID || 'G-XXXXXXXXXX',
    cloudflareBeaconToken: import.meta.env.VITE_CLOUDFLARE_BEACON_TOKEN || 'XXXXXXXXXX',
  },


  // Environment
  environment: import.meta.env.VITE_ENVIRONMENT || 'development',

  // App Configuration
  app: {
    name: '脑洞有AI',
    description: '1000+ Lovely Applications',
    url: 'https://minddock.ai',
    email: 'hello@minddock.ai',
  },

  // Social Links
  social: {
    email: 'mailto:contact@aiislove.tech',
    x: 'https://x.com/quyang_cd',
  },

  // External Apps
  externalApps: {
    lie: 'https://lie.minddock.ai',
    banana: 'https://banana.minddock.ai',
  },

  // Version Configuration
  version: {
    number: '1.0.0',
    isPreview: false, // Set to true for preview/beta releases
  },

  // Promo Modal Configuration
  promoModal: {
    enabled: false,
    storageKey: 'hasSeenNBTIPromo',
    delay: 1500,
    campaign: {
      id: 'nbti-2025',
      title: 'NBTI 脑不太行人格测试',
      subtitle: 'MBTI 测性格，NBTI 测脑子',
      description: '30 道题，2 分钟，精准诊断你的脑回路',
      url: 'http://nbti.aiislove.tech/',
      ctaText: '开始测试',
    },
  },
};